import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { BANNER_TYPE, calculateApplicationCompletionPercentage } from "constants/index";
import { Banner, BANNER_SIZE } from "components/Banner";
import ApplicantChecklistDisplay from "./ApplicantChecklistDisplay";
import { PrimaryLink } from "components/Links";
import Overlay from "components/Overlay";

/**
 * ApplicationProgressBanner
 *
 * @param {Object}   missionRoleApplicant
 */
const ApplicationProgressBanner = ({ missionRoleApplicant, ...props }) => {
  const completionPercentage = calculateApplicationCompletionPercentage(missionRoleApplicant?.applicationChecklist);

  const getCompletionBannerType = (percentage) => {
    if (percentage >= 80) return BANNER_TYPE.info;

    return BANNER_TYPE.warning;
  };

  return (
    <Banner
      isClosable={false}
      type={getCompletionBannerType(completionPercentage)}
      size={BANNER_SIZE.small}
      align="center"
      {...props}
    >
      <FormattedMessage
        id="Missions.MissionRole.ApplicationDetailsModal.CompletionPercentage"
        values={{
          percentage: Math.round(completionPercentage),
          progress: (
            <Overlay
              asCardOverlay
              overlay={<ApplicantChecklistDisplay missionRoleApplicant={missionRoleApplicant} />}
              trigger={
                <PrimaryLink onClick={(e) => e.preventDefault()}>
                  <FormattedMessage id="Missions.MissionRole.ApplicationDetailsModal.CompletionPercentage.Progress" />
                </PrimaryLink>
              }
              width="30rem"
            />
          ),
        }}
      />
    </Banner>
  );
};

ApplicationProgressBanner.propTypes = {
  missionRoleApplicant: PropTypes.object.isRequired,
};

export default ApplicationProgressBanner;
